var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { Form, Checkbox, Spin, Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import { pluck } from 'ramda';
import { Button } from 'ui/styled';
import { useTicketFlagsQuery } from 'apollo/queries/TICKET_FLAGS';
import useTeamUpdateTicketFlagsMutation from 'apollo/mutations/Teams/TEAM_UPDATE_TICKET_FLAGS';
import { useTeamTicketFlagsQuery } from 'apollo/queries/Teams/TEAM_TICKET_FLAGS';
import { StyledSearch } from 'ui/styled/Inputs';
import { calculateFlagChanges } from './helpers';
import { StickyFooter } from './styled';
var MAX_FLAGS = 100;
var FlagCheckbox = function (_a) {
    var flagId = _a.flagId, label = _a.label, disabled = _a.disabled, selectedFlags = _a.selectedFlags, setSelectedFlags = _a.setSelectedFlags;
    var isChecked = selectedFlags.includes(flagId);
    var onChange = function (e) {
        var checked = e.target.checked;
        var next = checked
            ? __spreadArray(__spreadArray([], selectedFlags, true), [flagId], false) : selectedFlags.filter(function (id) { return id !== flagId; });
        setSelectedFlags(next);
    };
    return (_jsx(Checkbox, { value: flagId, checked: isChecked, disabled: disabled, onChange: onChange, children: _jsx(Tooltip, { title: disabled
                ? "You can make up to ".concat(MAX_FLAGS, " changes from the original state. Please save your current changes and continue.")
                : null, children: _jsx("span", { children: label }) }) }, flagId));
};
var TicketFlags = function () {
    var _a;
    var id = useParams().id;
    var form = Form.useForm()[0];
    var _b = useState([]), initialFlags = _b[0], setInitialFlags = _b[1];
    var _c = useState([]), selectedFlags = _c[0], setSelectedFlags = _c[1];
    var _d = useState(''), search = _d[0], setSearch = _d[1];
    var _e = useTeamUpdateTicketFlagsMutation(), onUpdateTicketFlags = _e.onMutate, updateLoading = _e.loading;
    var _f = useTicketFlagsQuery({
        variables: { per_page: 1000 }
    }), ticketFlagsData = _f.data, ticketFlagsLoading = _f.loading;
    var _g = useTeamTicketFlagsQuery({ variables: { id: id } }), teamFlagsData = _g.data, teamLoading = _g.loading;
    var flags = useMemo(function () { var _a; return ((_a = ticketFlagsData === null || ticketFlagsData === void 0 ? void 0 : ticketFlagsData.ticket_flags) === null || _a === void 0 ? void 0 : _a.nodes) || []; }, [ticketFlagsData]);
    var teamFlags = useMemo(function () { var _a; return ((_a = teamFlagsData === null || teamFlagsData === void 0 ? void 0 : teamFlagsData.team) === null || _a === void 0 ? void 0 : _a.ticket_flags) || []; }, [(_a = teamFlagsData === null || teamFlagsData === void 0 ? void 0 : teamFlagsData.team) === null || _a === void 0 ? void 0 : _a.ticket_flags]);
    useEffect(function () {
        var initFlags = pluck('id', teamFlags);
        setInitialFlags(initFlags);
        setSelectedFlags(initFlags);
        form.setFieldsValue({ flags: initFlags });
    }, [form, teamFlags]);
    var currentChanges = useMemo(function () {
        var _a = calculateFlagChanges(initialFlags, selectedFlags), add_ids = _a.add_ids, remove_ids = _a.remove_ids, totalChangesCount = _a.totalChangesCount;
        return {
            add_ids: add_ids,
            remove_ids: remove_ids,
            totalChangesCount: totalChangesCount,
            allChangedIds: __spreadArray(__spreadArray([], add_ids, true), remove_ids, true)
        };
    }, [initialFlags, selectedFlags]);
    var _h = useMemo(function () {
        var allFlagIds = flags.map(function (f) { return f.id; });
        var totalSelectAll = calculateFlagChanges(initialFlags, allFlagIds).totalChangesCount;
        var totalClearAll = calculateFlagChanges(initialFlags, []).totalChangesCount;
        return {
            potentialTotalChanges: totalSelectAll,
            selectAllLimitExceeded: totalSelectAll > MAX_FLAGS,
            potentialClearAllChanges: totalClearAll,
            clearAllLimitExceeded: totalClearAll > MAX_FLAGS
        };
    }, [flags, initialFlags]), potentialTotalChanges = _h.potentialTotalChanges, selectAllLimitExceeded = _h.selectAllLimitExceeded, clearAllLimitExceeded = _h.clearAllLimitExceeded, potentialClearAllChanges = _h.potentialClearAllChanges;
    var filteredFlags = useMemo(function () {
        var query = search.trim().toLowerCase();
        if (!query)
            return flags;
        return flags.filter(function (flag) { return flag.display_name.toLowerCase().includes(query); });
    }, [flags, search]);
    var onFinish = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, add_ids, remove_ids, isErrorFree;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = calculateFlagChanges(initialFlags, selectedFlags), add_ids = _a.add_ids, remove_ids = _a.remove_ids;
                    return [4 /*yield*/, onUpdateTicketFlags({
                            team_id: id,
                            add_ids: add_ids,
                            remove_ids: remove_ids
                        })];
                case 1:
                    isErrorFree = (_b.sent()).isErrorFree;
                    if (isErrorFree) {
                        setInitialFlags(selectedFlags);
                        form.setFieldsValue({ flags: selectedFlags });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var showSpinner = ticketFlagsLoading || teamLoading || updateLoading;
    return (_jsx(Spin, { spinning: showSpinner, children: _jsxs(Form, { preserve: true, form: form, onFinish: onFinish, initialValues: { flags: initialFlags }, children: [_jsxs("div", { style: { display: 'flex', gap: 8, marginBottom: 8 }, children: [_jsx(StyledSearch, { placeholder: "Search flags...", allowClear: true, value: search, onChange: function (e) { return setSearch(e.target.value); }, width: "300px" }), _jsx(Tooltip, { title: selectAllLimitExceeded
                                ? "Selecting all flags would result in ".concat(potentialTotalChanges, " changes, exceeding the limit of ").concat(MAX_FLAGS, ".")
                                : null, children: _jsx(Button, { disabled: selectAllLimitExceeded, onClick: function () {
                                    var allFlagIds = filteredFlags.map(function (f) { return f.id; });
                                    form.setFieldValue('flags', allFlagIds);
                                    setSelectedFlags(allFlagIds);
                                }, children: "Select all" }) }), _jsx(Tooltip, { title: clearAllLimitExceeded
                                ? "Clearing all flags would result in ".concat(potentialClearAllChanges, " changes, exceeding the limit of ").concat(MAX_FLAGS, ".")
                                : null, children: _jsx(Button, { disabled: clearAllLimitExceeded, onClick: function () {
                                    var remainingFlags = selectedFlags.filter(function (id) { return !filteredFlags.some(function (f) { return f.id === id; }); });
                                    form.setFieldValue('flags', remainingFlags);
                                    setSelectedFlags(remainingFlags);
                                }, children: "Clear all" }) })] }), _jsx(Form.Item, { name: "flags", children: _jsx("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }, children: filteredFlags.map(function (flag) { return (_jsx(FlagCheckbox, { flagId: flag.id, label: flag.active
                                ? flag.display_name
                                : "".concat(flag.display_name, " (inactive)"), disabled: currentChanges.totalChangesCount >= MAX_FLAGS &&
                                !currentChanges.allChangedIds.includes(flag.id), selectedFlags: selectedFlags, setSelectedFlags: setSelectedFlags }, flag.id)); }) }) }), _jsx(StickyFooter, { children: _jsx(Button, { btntype: "primary", htmlType: "submit", loading: updateLoading, disabled: showSpinner || (currentChanges === null || currentChanges === void 0 ? void 0 : currentChanges.totalChangesCount) === 0, children: "Save" }, "submit") })] }) }));
};
export default TicketFlags;
